function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import ContentEditable from 'react-contenteditable';
import PropTypes from 'prop-types';
import { AppContext } from 'context';
import noteShape from 'shapes/noteShape';
import SendIcon from 'svg/send.svg';
import styles from './VisitNotes.pcss';
var _React_PureComponent;
class ReplyNoteForm extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        if (this.props.onDidMount) {
            setTimeout(()=>{
                this.props.onDidMount(this.replyNoteWrapperRef);
            }, 0);
        }
        this.replyNoteRef.current.focus();
    }
    onChange(evt) {
        const replyContent = evt.currentTarget.textContent;
        this.setState({
            replyContent
        });
        this.props.onChange(replyContent);
    }
    onSubmit() {
        const { replyContent } = this.state;
        this.props.onSubmit(replyContent);
    }
    onKeyDown(evt) {
        switch(evt.keyCode){
            // If Enter
            case 13:
                evt.stopPropagation();
                if (!evt.shiftKey && this.replyNoteRef.current) {
                    this.replyNoteRef.current.blur();
                    this.onSubmit();
                }
                break;
            // if Esc
            case 27:
                evt.stopPropagation();
                this.props.onCancel();
                break;
            default:
                break;
        }
    }
    renderSendBtn() {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /*#__PURE__*/ _jsx("div", {
            className: cn(styles.replyNoteEditor__sendBtn, {
                [styles['replyNoteEditor__sendBtn--active']]: !!this.state.replyContent
            }, {
                [styles['replyNoteEditor__sendBtn--mobile']]: this.context.displayMode === 'mobile'
            }),
            onClick: ()=>!!this.state.replyContent && this.onSubmit(),
            children: /*#__PURE__*/ _jsx(SendIcon, {})
        }));
    }
    renderActionButtons() {
        if (!this.props.withActionButtons) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.replyNoteEditor__buttonsContainer,
            children: this.renderSendBtn()
        });
    }
    render() {
        const { note, withActionButtons } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            ref: this.replyNoteWrapperRef,
            className: cn('pseudoEditorWrapper', styles.replyNoteEditorWrapper),
            children: [
                /*#__PURE__*/ _jsx(ContentEditable, {
                    className: cn('pseudoEditor', styles.replyNoteEditor, {
                        [styles['replyNoteEditor--withActionButtons']]: withActionButtons
                    }),
                    innerRef: this.replyNoteRef,
                    html: this.state.replyContent,
                    onKeyDown: (evt)=>this.onKeyDown(evt),
                    onChange: (evt)=>this.onChange(evt),
                    onBlur: withActionButtons ? null : ()=>this.onSubmit()
                }),
                this.renderActionButtons()
            ]
        }, note.noteId);
    }
    constructor(props){
        super(props);
        this.replyNoteRef = /*#__PURE__*/ React.createRef();
        this.replyNoteWrapperRef = /*#__PURE__*/ React.createRef();
        this.state = {
            replyContent: ''
        };
    }
}
_define_property(ReplyNoteForm, "contextType", AppContext);
_define_property(ReplyNoteForm, "propTypes", {
    note: noteShape,
    withActionButtons: PropTypes.bool,
    onCancel: PropTypes.func,
    onDidMount: PropTypes.func,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func
});
_define_property(ReplyNoteForm, "defaultProps", {
    withActionButtons: false
});
export default ReplyNoteForm;
